import axiosPrivate from "../../../api/axiosPrivate";
import {
  ACTIVATE_USER,
  DEACTIVATE_USER,
  CREATE_USER,
  GET_ALL_USERS,
  GET_SINGLE_USER,
  UPDATE_USER,
  UNLOCK_USER,
  CHANGE_PASSWORD,
  SEARCH_USER,
  TRANSFER_CUSTOMER,
} from "../../../api/constant";

// Create new users
const createUser = async (userData) => {
  const response = await axiosPrivate.post(CREATE_USER, userData);
  return response.data;
};

// Fetch all users
const getAllUsers = async (pageNumber) => {
  const response = await axiosPrivate.get(
    `${GET_ALL_USERS}?page=${pageNumber}`
  );
  return response.data;
};

// Fetch single user
const getSingleUser = async (id) => {
  const response = await axiosPrivate.get(`${GET_SINGLE_USER}/${id}`);
  return response.data;
};

// Fetch single user
const unlockUser = async (id) => {
  const response = await axiosPrivate.get(`${UNLOCK_USER}/${id}`);
  return response.data;
};

// Update single user
const updateUser = async (userData) => {
  const response = await axiosPrivate.post(
    `${UPDATE_USER}/${userData.id}`,
    userData
  );
  return response.data;
};

// deactivate user
const deactivateUser = async (staff_id) => {
  const payload = {
    user_id: staff_id,
  };
  const response = await axiosPrivate.post(DEACTIVATE_USER, payload);
  return response.data;
};

// activate user
const activateUser = async (staff_id) => {
  const payload = {
    user_id: staff_id,
  };
  const response = await axiosPrivate.post(ACTIVATE_USER, payload);
  return response.data;
};

// activate user
const changePassword = async (values) => {
  const response = await axiosPrivate.post(
    `${CHANGE_PASSWORD}/${values?.id}`,
    values
  );
  return response.data;
};

//search user
const searchUsers = async (data) => {
  const response = await axiosPrivate.get(
    `${SEARCH_USER}?office_id=${data.office_id}&search=${data.searchText}`
  );
  return response.data;
};

const getUserCustomers = async (data) => {
  const response = await axiosPrivate.get(
    `/staff/${data.id}/customers?search=${data.searchBy}`
  );
  return response.data;
};

const transferCustomer = async (values) => {
  const response = await axiosPrivate.patch(
    TRANSFER_CUSTOMER,
    values
  );
  return response.data;
};

const userService = {
  getAllUsers,
  getSingleUser,
  deactivateUser,
  activateUser,
  createUser,
  updateUser,
  unlockUser,
  changePassword,
  searchUsers,
  getUserCustomers,
  transferCustomer
};

export default userService;
